import OlMap from 'ol/Map';
import './proj/epsg3395';

class Map extends OlMap {
  constructor({
    player,
    ...options
  }) {
    super(options);
    this.player = player;
    this.currentZoom = this.getView().getZoom();
    this.lastRefreshTime = this.player.currentTime;
    this.lastRefreshRequest = null;
    this.tileRefreshDebounce = options.tileRefreshDebounce;
  }

}

export default Map;